<div class="row">
  <edit-accessrights
    [columns]="columns"
    [people]="people"
    [processing]="processing"
    [accessRights]="accessRights"
    (toggleSaveAccessRights)="save($event)"
    (toggleCancel)="cancel()"
  ></edit-accessrights>
</div>
